module.exports = __webpack_public_path__ + "img/img-biggaming-d.b54d609a.png";